<input
  class="viewer-pen-width-slider"
  type="range"
  [step]="step"
  [min]="min"
  [max]="max"
  [(ngModel)]="width"
  (change)="widthChange.emit(width)"
/>
<div class="value-label">{{ width }}px</div>
